import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { NotificationService } from '../../core/services/notification.service';
import {ActivityStatus} from "../models/activity-status/activity-status";
import { Observable } from 'rxjs';
import { KeyValueObject } from '../models/core/KeyValueObject';
import { DataSourceRequestState, toDataSourceRequestString } from '@progress/kendo-data-query';

@Injectable()
export class ActivityStatusesService extends DataService<ActivityStatus, ActivityStatus> {

	constructor(
		http: HttpClient,
		notificationService: NotificationService) {
		super(http, notificationService);

		this.controllerName = 'activity-statuses';
	}

	getLookupData(state: DataSourceRequestState = null): Observable<KeyValueObject[]> {
		return this.getQuery(`${this.baseUrl()}/lookup-data${this.getRequestQueryString(state)}`);
	}

	protected getRequestQueryString(state: DataSourceRequestState, symbol: string = "?"): string {
			return state ? `${symbol}${toDataSourceRequestString(state)}` : '';
		}
}
